import { Pipe, PipeTransform } from '@angular/core';
import currencies from '../models/currencies.json';

@Pipe({
  name: 'mycurrency',
  standalone: false,
})
export class MyCurrencyPipe implements PipeTransform {
  transform(value: number): string {
    const businessName = localStorage.getItem('businessName');
    const currency = localStorage.getItem(businessName + '-currency');
    const currencySymbol = currencies.find((c) => c.id === currency)?.symbol;
    if (value.toFixed) {
      value = Number(value.toFixed(2));
    }

    return `${value}${currencySymbol || ''}`;
  }
}
